import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ReachOurCaboOffice from "./sections/ReachOurCaboOffice";
import PartnerWithUs from "./sections/PartnerWithUs";
import FooterLegal from "@/reusable_sections/Footer";
import Officelocationmap from "./sections/Officelocationmap";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <PartnerWithUs />
      <ReachOurCaboOffice />
      <Officelocationmap />
      <FooterLegal />
    </div>;
}